module.exports = __webpack_public_path__ + "static/media/dp.a5369809.webp";